/**
 * `?redirect=` values come from the URL, so they are attacker-controlled. Only
 * a same-origin path may be followed: absolute URLs and protocol-relative
 * `//evil.com` would turn the post-login redirect into an open redirect.
 * Mirrors the checks in `src/proxy.ts` (`getValidRedirect`), which additionally
 * refuses auth pages for its own loop-avoidance reasons.
 */
export function getSafeRedirectPath(param: string | null | undefined): string | null {
  if (!param) return null;
  // Browsers parse `\` as `/`, so `/\evil.com` becomes `//evil.com`.
  if (param.includes('\\')) return null;
  if (!param.startsWith('/')) return null;
  if (param.startsWith('//')) return null;
  if (param.includes('://')) return null;
  return param;
}
